module["exports"] = [
  "Gruppen",
  "AS",
  "ASA",
  "BA",
  "RFH",
  "og Sønner"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/company/suffix.js
// module id = 1467
// module chunks = 0